import { useState } from "react";
import { Check, ChevronDown, ChevronUp } from "lucide-react";

const servicesData = [
  {
    id: "weddings",
    title: "Weddings",
    description: "Your love story deserves to be captured beautifully. I'll be there for you as if you were family.",
    image: "https://static.wixstatic.com/media/3a96ea_64b80372f19347d79b2d76c488a1aa55~mv2.jpeg/v1/fill/w_980,h_749,q_90,enc_avif,quality_auto/3a96ea_64b80372f19347d79b2d76c488a1aa55~mv2.jpeg",
    galleryImages: [
      "https://static.wixstatic.com/media/3a96ea_18b45f5119ee4780a88ee45ba0d09ffd~mv2.jpg/v1/fill/w_485,h_323,q_90,enc_avif,quality_auto/3a96ea_18b45f5119ee4780a88ee45ba0d09ffd~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_850ee4615b4a49e69ad62f95636a1362~mv2.jpg/v1/fill/w_485,h_323,q_90,enc_avif,quality_auto/3a96ea_850ee4615b4a49e69ad62f95636a1362~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_8772888651704ce197157035538ff717~mv2.jpg/v1/fill/w_502,h_764,q_90,enc_avif,quality_auto/3a96ea_8772888651704ce197157035538ff717~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_f473ca6f56824cf89f2cb744b5bf4471~mv2.jpg/v1/fill/w_469,h_764,q_90,enc_avif,quality_auto/3a96ea_f473ca6f56824cf89f2cb744b5bf4471~mv2.jpg"
    ],
    packages: [
      {
        name: "The Essential Package",
        price: "$2,600",
        features: [
          "6 Hours Coverage",
          "Custom Timeline",
          "Online Gallery"
        ],
        description: "Perfect for intimate weddings or shorter timelines."
      },
      {
        name: "The Signature Package",
        price: "$3,500",
        popular: true,
        features: [
          "8 Hours Coverage",
          "Engagements Session",
          "Bridals Session",
          "Custom Timeline",
          "Online Gallery"
        ],
        description: "Full day coverage with a relaxed, flexible timeline."
      },
      {
        name: "The Luxury Package",
        price: "$4,200",
        features: [
          "8 Hours Coverage",
          "Engagement Session",
          "Bridal Session",
          "Bridal Boudoir Session",
          "Photobooth",
          "Content Video Creator",
          "Audio Guest Book",
          "Custom Timeline",
          "Online Gallery"
        ],
        description: "The BEST VALUE - everything bundled for a stress-free experience."
      }
    ],
    addOns: {
      title: "Discounted Add Ons",
      items: [
        { name: "Engagements", price: "$325" },
        { name: "Bridals", price: "$375" },
        { name: "Content Creator", price: "$425" },
        { name: "Boudoir", price: "$325" },
        { name: "Photo Booth", price: "$300" },
        { name: "360 Booth", price: "$500" },
        { name: "Audio Guest Book", price: "$175" },
        { name: "Second Photographer", price: "$75/hr" }
      ],
      note: "A travel fee may be added. A 20% non-refundable deposit is required to book."
    }
  },
  {
    id: "seniors",
    title: "Seniors",
    description: "Celebrate this milestone with portraits that showcase your unique personality and style.",
    image: "https://static.wixstatic.com/media/3a96ea_5fd6c442c000471f9ad839a14d32158c~mv2.jpg/v1/fill/w_463,h_760,q_90,enc_avif,quality_auto/3a96ea_5fd6c442c000471f9ad839a14d32158c~mv2.jpg",
    galleryImages: [
      "https://static.wixstatic.com/media/3a96ea_217e5526aa2e494b8abb5e20d1a6dde2~mv2.jpg/v1/fill/w_241,h_160,q_90,enc_avif,quality_auto/3a96ea_217e5526aa2e494b8abb5e20d1a6dde2~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_ef971370245b4e4ea70841c4fc7e4b49~mv2.jpg/v1/fill/w_241,h_374,q_90,enc_avif,quality_auto/3a96ea_ef971370245b4e4ea70841c4fc7e4b49~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_2264f05398354338bb7617b83c4a3910~mv2.jpg/v1/fill/w_362,h_544,q_90,enc_avif,quality_auto/3a96ea_2264f05398354338bb7617b83c4a3910~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_bf6bb5716d8d4291b7ac2e84d4e70d22~mv2.jpeg/v1/fill/w_357,h_544,q_90,enc_avif,quality_auto/3a96ea_bf6bb5716d8d4291b7ac2e84d4e70d22~mv2.jpeg"
    ],
    packages: [
      {
        name: "Package 1",
        price: "$475",
        features: [
          "60 Minute Session",
          "20 Edited Digital Images",
          "Online Gallery",
          "1-2 Outfits"
        ],
        description: "Great starter package for capturing your senior year."
      },
      {
        name: "Package 2",
        price: "$525",
        popular: true,
        features: [
          "90 Minute Session",
          "40 Edited Digital Images",
          "Online Gallery",
          "1-3 Outfits"
        ],
        description: "More time for variety and creative shots."
      },
      {
        name: "Package 3",
        price: "$575",
        features: [
          "2 Hour Session",
          "60 Edited Digital Images",
          "Online Gallery",
          "1-4 Outfits"
        ],
        description: "The ultimate senior experience with maximum variety."
      }
    ],
    addOns: "$75 non-refundable deposit required. Location and travel fees may apply."
  },
  {
    id: "family",
    title: "Family",
    description: "Capture the love and connection of your growing family with timeless portraits.",
    image: "https://static.wixstatic.com/media/3a96ea_e0c10ab5d70c476298f245938b6a4c67~mv2.jpeg/v1/fill/w_980,h_733,q_90,enc_avif,quality_auto/3a96ea_e0c10ab5d70c476298f245938b6a4c67~mv2.jpeg",
    galleryImages: [
      "https://static.wixstatic.com/media/3a96ea_99f9e83075124bea865cf2c932373a40~mv2.jpg/v1/fill/w_510,h_340,q_90,enc_avif,quality_auto/3a96ea_99f9e83075124bea865cf2c932373a40~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_f25826fd15ee472689e450c2ee23ffec~mv2.jpg/v1/fill/w_460,h_340,q_90,enc_avif,quality_auto/3a96ea_f25826fd15ee472689e450c2ee23ffec~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_44a507acaa9e42b79b83e08e36737466~mv2.jpeg/v1/fill/w_345,h_415,q_90,enc_avif,quality_auto/3a96ea_44a507acaa9e42b79b83e08e36737466~mv2.jpeg",
      "https://static.wixstatic.com/media/3a96ea_e353880e1c13440e8013c4875b672ae8~mv2.jpg/v1/fill/w_625,h_415,q_90,enc_avif,quality_auto/3a96ea_e353880e1c13440e8013c4875b672ae8~mv2.jpg"
    ],
    packages: [
      {
        name: "Classic Session",
        price: "$350",
        features: [
          "30 Minute Session",
          "15 Edited Digital Images",
          "Online Gallery",
          "1 Location"
        ],
        description: "Perfect for quick family updates and holiday cards."
      },
      {
        name: "Essential Session",
        price: "$425",
        popular: true,
        features: [
          "60 Minute Session",
          "30 Edited Digital Images",
          "Online Gallery",
          "1 Location"
        ],
        description: "More time for candid moments and variety."
      },
      {
        name: "Extended Session",
        price: "$600",
        features: [
          "75 Minute Session",
          "40 Edited Digital Images",
          "Online Gallery",
          "1 Location",
          "Parents, Grandparents, Kids, Grandkids"
        ],
        description: "The full family experience with extended family included."
      }
    ],
    addOns: null
  },
  {
    id: "boudoir",
    title: "Boudoir",
    description: "Celebrate your confidence and beauty with an empowering, intimate session.",
    image: "https://static.wixstatic.com/media/3a96ea_de742eae6ad0493f90e9003c53d30682~mv2.jpeg/v1/fill/w_299,h_447,q_90,enc_avif,quality_auto/3a96ea_de742eae6ad0493f90e9003c53d30682~mv2.jpeg",
    galleryImages: [
      "https://static.wixstatic.com/media/3a96ea_3bfc3ec843084a1fb49db815da19cf74~mv2.jpeg/v1/fill/w_671,h_447,q_90,enc_avif,quality_auto/3a96ea_3bfc3ec843084a1fb49db815da19cf74~mv2.jpeg",
      "https://static.wixstatic.com/media/3a96ea_c166b2b2c099452886a40c8388e4b9a0~mv2.jpeg/v1/fill/w_466,h_754,q_90,enc_avif,quality_auto/3a96ea_c166b2b2c099452886a40c8388e4b9a0~mv2.jpeg",
      "https://static.wixstatic.com/media/3a96ea_95602f7fb6ba49fd8e8951eba6689e2c~mv2.jpeg/v1/fill/w_504,h_754,q_90,enc_avif,quality_auto/3a96ea_95602f7fb6ba49fd8e8951eba6689e2c~mv2.jpeg",
      "https://static.wixstatic.com/media/3a96ea_f1f950137d044661b9743e55b4f5187e~mv2.jpeg/v1/fill/w_464,h_729,q_90,enc_avif,quality_auto/3a96ea_f1f950137d044661b9743e55b4f5187e~mv2.jpeg"
    ],
    packages: [
      {
        name: "The Tease",
        price: "$375",
        features: [
          "45 Minute Session",
          "15 Edited Digital Images",
          "Online Gallery",
          "1-2 Outfit Changes",
          "Posing Guidance",
          "Hair & makeup not included, but I can refer someone",
          "Boudoir client closet available"
        ],
        description: "A taste of the boudoir experience."
      },
      {
        name: "The Reveal",
        price: "$475",
        popular: true,
        features: [
          "90 Minute Session",
          "30 Edited Digital Images",
          "Online Gallery",
          "2-3 Outfit Changes",
          "Posing Guidance",
          "Hair & makeup not included, but I can refer someone",
          "Boudoir client closet available"
        ],
        description: "Our most popular boudoir experience."
      },
      {
        name: "The Full Experience",
        price: "$625",
        features: [
          "2 Hour Session",
          "50 Edited Digital Images",
          "Online Gallery",
          "Unlimited Outfit Changes",
          "Posing Guidance",
          "Hair & makeup not included, but I can refer someone",
          "Boudoir client closet available"
        ],
        description: "The ultimate luxury boudoir experience."
      }
    ],
    addOns: {
      title: "Discounted Add Ons",
      items: [
        { name: "Additional Images", price: "$75" }
      ]
    }
  },
  {
    id: "branding",
    title: "Branding",
    description: "Elevate your business with professional imagery that tells your brand's story.",
    image: "https://static.wixstatic.com/media/3a96ea_ef68dfd7ec194aadbf566e21b9509460~mv2.jpg/v1/fill/w_980,h_1146,q_90,enc_avif,quality_auto/3a96ea_ef68dfd7ec194aadbf566e21b9509460~mv2.jpg",
    galleryImages: [
      "https://static.wixstatic.com/media/3a96ea_f7ae28304ab5406eae279b6b10405bbf~mv2.jpg/v1/fill/w_505,h_712,q_90,enc_avif,quality_auto/3a96ea_f7ae28304ab5406eae279b6b10405bbf~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_d54a403aa9d34d85afac3d2d0cb0111c~mv2.jpg/v1/fill/w_465,h_712,q_90,enc_avif,quality_auto/3a96ea_d54a403aa9d34d85afac3d2d0cb0111c~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_ef68dfd7ec194aadbf566e21b9509460~mv2.jpg/v1/fill/w_980,h_1146,q_90,enc_avif,quality_auto/3a96ea_ef68dfd7ec194aadbf566e21b9509460~mv2.jpg"
    ],
    packages: [
      {
        name: "Starter Brand",
        price: "$400",
        features: [
          "60 Minute Session",
          "20 Edited Digital Images",
          "Online Gallery",
          "1 Location",
          "Social Media Ready Files"
        ],
        description: "Perfect for solopreneurs and small businesses."
      },
      {
        name: "Full Brand Story",
        price: "$600",
        popular: true,
        features: [
          "2 Hour Session",
          "50 Edited Digital Images",
          "Online Gallery",
          "2 Locations",
          "Social Media Ready Files",
          "Brand Consultation"
        ],
        description: "Complete brand imagery for your business."
      }
    ],
    addOns: "$75 studio fee may be applied."
  },
  {
    id: "maternity",
    title: "Maternity",
    description: "Celebrate this beautiful chapter with timeless portraits of your growing bump.",
    image: "https://static.wixstatic.com/media/3a96ea_fb4ed5324cc243d68bc050706da052d6~mv2.jpeg/v1/fill/w_487,h_726,q_90,enc_avif,quality_auto/3a96ea_fb4ed5324cc243d68bc050706da052d6~mv2.jpeg",
    galleryImages: [
      "https://static.wixstatic.com/media/3a96ea_b84a5c0e4ebc496599299cd7fdac7569~mv2.jpg/v1/fill/w_304,h_497,q_90,enc_avif,quality_auto/3a96ea_b84a5c0e4ebc496599299cd7fdac7569~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_5aad59d8242844daa87d798c435d7407~mv2.jpeg/v1/fill/w_325,h_497,q_90,enc_avif,quality_auto/3a96ea_5aad59d8242844daa87d798c435d7407~mv2.jpeg",
      "https://static.wixstatic.com/media/3a96ea_bf891bd682a24c87a46c2547a4e7e80f~mv2.jpg/v1/fill/w_331,h_497,q_90,enc_avif,quality_auto/3a96ea_bf891bd682a24c87a46c2547a4e7e80f~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_430babbf2d7d40f7b5f5ccf94cbfdc60~mv2.jpg/v1/fill/w_483,h_726,q_90,enc_avif,quality_auto/3a96ea_430babbf2d7d40f7b5f5ccf94cbfdc60~mv2.jpg"
    ],
    packages: [
      {
        name: "Package 1",
        price: "$375",
        features: [
          "30 Minute Session",
          "12 Edited Digital Images",
          "Online Gallery"
        ],
        description: "Simple and sweet maternity portraits."
      },
      {
        name: "Package 2",
        price: "$425",
        popular: true,
        features: [
          "60 Minute Session",
          "30 Edited Digital Images",
          "Online Gallery",
          "Outfit Changes",
          "Partner & Sibling Inclusion"
        ],
        description: "More time for variety and family inclusion."
      }
    ],
    addOns: "Best scheduled between 28-34 weeks. Gown rentals available."
  },
  {
    id: "couples",
    title: "Couples",
    description: "Whether engaged or just in love, capture your connection with beautiful portraits.",
    image: "https://static.wixstatic.com/media/3a96ea_468f6f8dbf52444a9eee07649207629b~mv2.jpeg/v1/fill/w_980,h_797,q_90,enc_avif,quality_auto/3a96ea_468f6f8dbf52444a9eee07649207629b~mv2.jpeg",
    galleryImages: [
      "https://static.wixstatic.com/media/3a96ea_50a574b440ea43d181966cc71c695258~mv2.jpeg/v1/fill/w_439,h_661,q_90,enc_avif,quality_auto/3a96ea_50a574b440ea43d181966cc71c695258~mv2.jpeg",
      "https://static.wixstatic.com/media/3a96ea_a8dbdc27a0f248f5879c6998465d1d03~mv2.jpg/v1/fill/w_531,h_661,q_90,enc_avif,quality_auto/3a96ea_a8dbdc27a0f248f5879c6998465d1d03~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_468f6f8dbf52444a9eee07649207629b~mv2.jpeg/v1/fill/w_980,h_797,q_90,enc_avif,quality_auto/3a96ea_468f6f8dbf52444a9eee07649207629b~mv2.jpeg"
    ],
    packages: [
      {
        name: "Mini Session",
        price: "$375",
        features: [
          "30 Minute Session",
          "15 Edited Digital Images",
          "Online Gallery",
          "1 Location"
        ],
        description: "Quick and romantic session for couples."
      },
      {
        name: "Full Session",
        price: "$425",
        popular: true,
        features: [
          "60 Minute Session",
          "30 Edited Digital Images",
          "Online Gallery",
          "1 Location"
        ],
        description: "Extended session with more variety and locations."
      }
    ],
    addOns: "Engagement sessions can be applied to wedding packages."
  },
  {
    id: "newborn",
    title: "Lifestyle Newborn",
    description: "Natural, in-home sessions capturing the precious first days with your new baby.",
    image: "https://static.wixstatic.com/media/3a96ea_e9dd9c9f26bc468587ffd766634fa985~mv2.jpg/v1/fill/w_980,h_653,q_90,enc_avif,quality_auto/3a96ea_e9dd9c9f26bc468587ffd766634fa985~mv2.jpg",
    galleryImages: [
      "https://static.wixstatic.com/media/3a96ea_0b3c5e2a30de493bbd306ab8abb227a6~mv2.jpg/v1/fill/w_980,h_653,q_90,enc_avif,quality_auto/3a96ea_0b3c5e2a30de493bbd306ab8abb227a6~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_e18c5583a2ee43bc8e1aa96bbc1a6a69~mv2.jpeg/v1/fill/w_485,h_729,q_90,enc_avif,quality_auto/3a96ea_e18c5583a2ee43bc8e1aa96bbc1a6a69~mv2.jpeg",
      "https://static.wixstatic.com/media/3a96ea_f4ccda1c05d24997bcc43c8d7c06d94f~mv2.jpg/v1/fill/w_485,h_729,q_90,enc_avif,quality_auto/3a96ea_f4ccda1c05d24997bcc43c8d7c06d94f~mv2.jpg",
      "https://static.wixstatic.com/media/3a96ea_e9dd9c9f26bc468587ffd766634fa985~mv2.jpg/v1/fill/w_980,h_653,q_90,enc_avif,quality_auto/3a96ea_e9dd9c9f26bc468587ffd766634fa985~mv2.jpg"
    ],
    packages: [
      {
        name: "Petite Session",
        price: "$500",
        features: [
          "60 Minute In-Home Session",
          "15 Edited Digital Images",
          "Online Gallery",
          "Baby & Parent Poses"
        ],
        description: "Sweet and simple newborn portraits."
      },
      {
        name: "Full Lifestyle Session",
        price: "$550",
        popular: true,
        features: [
          "90 Minute In-Home Session",
          "30 Edited Digital Images",
          "Online Gallery",
          "Baby, Parent & Sibling Poses",
          "Family Portraits Included",
          "Nursery Details"
        ],
        description: "Complete lifestyle newborn experience."
      }
    ],
    addOns: "Best scheduled within first 2 weeks (4-11 days ideal). Sibling and pet inclusion welcome."
  }
];

const ServicesSection = ({ isVisible }) => {
  const [expandedService, setExpandedService] = useState(null);

  const toggleService = (serviceId) => {
    setExpandedService(expandedService === serviceId ? null : serviceId);
  };

  const scrollToBooking = () => {
    const element = document.querySelector("#booking");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="services"
      className="py-24 lg:py-32 bg-[#FDFBF9]"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div
          className={`text-center mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <p className="overline text-[#C8A99C] mb-4">What I Offer</p>
          <h2 className="font-heading text-4xl lg:text-5xl font-light tracking-tight text-[#2C2A28] mb-6">
            Services & Pricing
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <p className="font-body text-[#5C5A56] max-w-2xl mx-auto">
            Every session is tailored to you. Click on any service to explore packages and find the perfect fit for your needs.
          </p>
        </div>

        {/* Services Accordion */}
        <div className="space-y-4">
          {servicesData.map((service, index) => (
            <div
              key={service.id}
              className={`border border-[#E8E4DD] bg-white overflow-hidden transition-all duration-500 ${
                isVisible
                  ? `animate-fade-in-up`
                  : "opacity-0"
              }`}
              style={{ animationDelay: `${index * 50}ms` }}
              data-testid={`service-${service.id}`}
            >
              {/* Service Header */}
              <button
                onClick={() => toggleService(service.id)}
                className="w-full flex items-center gap-6 p-6 hover:bg-[#F5F2EB]/50 transition-colors"
                data-testid={`service-toggle-${service.id}`}
              >
                <div className="w-20 h-20 flex-shrink-0 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-grow text-left">
                  <h3 className="font-heading text-2xl text-[#2C2A28]">
                    {service.title}
                  </h3>
                  <p className="font-body text-sm text-[#5C5A56] mt-1 hidden sm:block">
                    {service.description}
                  </p>
                </div>
                <div className="flex items-center gap-4">
                  <span className="font-body text-sm text-[#C8A99C] hidden md:block">
                    {service.packages.length} packages
                  </span>
                  {expandedService === service.id ? (
                    <ChevronUp size={24} className="text-[#5C5A56]" />
                  ) : (
                    <ChevronDown size={24} className="text-[#5C5A56]" />
                  )}
                </div>
              </button>

              {/* Expanded Packages */}
              {expandedService === service.id && (
                <div className="border-t border-[#E8E4DD] bg-[#F5F2EB]/30 p-6 lg:p-8">
                  <p className="font-body text-[#5C5A56] mb-8 sm:hidden">
                    {service.description}
                  </p>

                  {/* Gallery Images */}
                  {service.galleryImages && service.galleryImages.length > 0 && (
                    <div className="mb-8">
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                        {service.galleryImages.map((img, imgIndex) => (
                          <div key={imgIndex} className="aspect-[4/5] overflow-hidden">
                            <img
                              src={img}
                              alt={`${service.title} sample ${imgIndex + 1}`}
                              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  <div className={`grid grid-cols-1 ${service.packages.length === 2 ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-6`}>
                    {service.packages.map((pkg, pkgIndex) => (
                      <div
                        key={pkgIndex}
                        className={`bg-white p-6 relative ${
                          pkg.popular ? "ring-2 ring-[#C8A99C]" : "border border-[#E8E4DD]"
                        }`}
                        data-testid={`package-${service.id}-${pkgIndex}`}
                      >
                        {pkg.popular && (
                          <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                            <span className="bg-[#C8A99C] text-white text-xs px-3 py-1 font-body uppercase tracking-wider">
                              Most Popular
                            </span>
                          </div>
                        )}
                        
                        <h4 className="font-heading text-xl text-[#2C2A28] mb-2 mt-2">
                          {pkg.name}
                        </h4>
                        <p className="font-heading text-3xl text-[#2C2A28] mb-4">
                          {pkg.price}
                        </p>
                        <p className="font-body text-sm text-[#5C5A56] mb-6">
                          {pkg.description}
                        </p>
                        
                        <ul className="space-y-3 mb-6">
                          {pkg.features.map((feature, featureIndex) => (
                            <li key={featureIndex} className="flex items-start gap-3">
                              <Check size={16} className="text-[#A8B5A3] mt-0.5 flex-shrink-0" />
                              <span className="font-body text-sm text-[#5C5A56]">
                                {feature}
                              </span>
                            </li>
                          ))}
                        </ul>
                        
                        <button
                          onClick={scrollToBooking}
                          className={`w-full py-3 font-body text-sm tracking-wide transition-all duration-300 ${
                            pkg.popular
                              ? "bg-[#2C2A28] text-[#FDFBF9] hover:bg-[#5C5A56]"
                              : "border border-[#2C2A28] text-[#2C2A28] hover:bg-[#2C2A28] hover:text-[#FDFBF9]"
                          }`}
                          data-testid={`book-${service.id}-${pkgIndex}`}
                        >
                          Book This Package
                        </button>
                      </div>
                    ))}
                  </div>
                  
                  {service.addOns && typeof service.addOns === "object" ? (
                    <div className="mt-8 border-t border-[#E8E4DD] pt-6" data-testid={`addons-${service.id}`}>
                      <h5 className="font-heading text-lg text-[#2C2A28] text-center uppercase tracking-wider mb-4">
                        {service.addOns.title}
                      </h5>
                      <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4">
                        {service.addOns.items.map((item, i) => (
                          <span key={i} className="font-body text-sm text-[#5C5A56]">
                            <span className="text-[#2C2A28] font-medium">{item.name}:</span> {item.price}
                          </span>
                        ))}
                      </div>
                      <p className="font-body text-xs text-[#5C5A56] text-center italic">
                        {service.addOns.note}
                      </p>
                    </div>
                  ) : service.addOns ? (
                    <p className="font-body text-xs text-[#5C5A56] mt-6 text-center">
                      {service.addOns}
                    </p>
                  ) : null}

                  <p className="font-body text-xs text-[#C8A99C] mt-4 text-center font-medium">
                    Option to upgrade your gallery
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Note */}
        <p className="text-center font-body text-sm text-[#5C5A56] mt-12">
          * A non-refundable deposit is required to book. Travel fees may apply for locations outside the Breaux Bridge/Lafayette area.
        </p>
      </div>
    </section>
  );
};

export default ServicesSection;
